// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"View5_wrapper__1pCqo","topRow":"View5_topRow__2D-pZ","mainUser":"View5_mainUser__1cYrU","user":"View5_user__3AQK9","bottomRow":"View5_bottomRow__8qKoR"};